import { PersonBookProvider, PersonForm, resetError, TUpdateOrderType } from 'entities/person';
import { FC } from 'react';
import { useEscapeById, useModal } from 'shared/lib/modal';
import { useAppDispatch } from 'shared/lib/store';
import { PenIconButton } from 'shared/ui/buttons/iconButtons/penButton';
import { PlusButton } from 'shared/ui/buttons/iconButtons/plusButton';
import { ModalCard } from 'shared/ui/cards/modalCard';

interface PersonModalEditProps {
	updatePersonBook?: boolean;
	updateOrder?: TUpdateOrderType;
  headerContent?: string;
  isCreate?: boolean;
  addGuestInOrder?: () => void;
}

export const PersonModalEdit: FC<PersonModalEditProps> = ({
	updatePersonBook,
	updateOrder,
  headerContent = 'Отредактируйте данные',
  isCreate = false,
  addGuestInOrder,
}) => {
	const { openModal } = useModal();
	const dispatch = useAppDispatch();

	const openEditModal = () => {
		openModal();
	};

	const onClose = () => {
		dispatch(resetError());
	};

	useEscapeById('person-edit-modal');

	return (
		<>
      {
      isCreate ?
      <PlusButton onClick={openEditModal} backgroundMain light disableTouch /> :
      <PenIconButton onClick={openEditModal} backgroundMain light disableTouch />
      }
			<ModalCard
				headerContent={headerContent}
				styles={{ width: '425px', height: '565px', fontSize: 'medium' }}
				indentsCard={false}
				onClose={onClose}
				id="person-edit-modal"
				zIndex={1000}
			>
        {updatePersonBook ? 
          <PersonForm
            updatePersonBook={updatePersonBook}
            updateOrder={updateOrder}
            isCreate={isCreate}
            addGuestInOrder={addGuestInOrder}
          /> :
          <PersonBookProvider>
            <PersonForm
              updatePersonBook={updatePersonBook}
              updateOrder={updateOrder}
              isCreate={isCreate}
              addGuestInOrder={addGuestInOrder}
            /> 
          </PersonBookProvider>
        }
			</ModalCard>
		</>
	);
};
